export const BRIDGE_HELMET_TITLE =
  'FusionX | Decentralized Exchange | Bridge'
